import { z } from 'zod';
import { BaseSchema } from '../base/base.entity.model';
import * as FlatModels from '../../internal';

export const MetadataSchema = BaseSchema.extend({
  title: z.string().max(255),
  keywords: z.string().max(255),
  description: z.string().max(255),
  carouselMedia: z.string().uuid().optional().nullable(),
  carouselTitle: z.string().max(255),
  carouselCopyright: z.string().max(255),
  carouselTextColor: z.string().max(255),
  carouselShowSubjects: z.boolean(),
  supportEmail: z.string().email().max(255),
});

export type Metadata = z.infer<typeof MetadataSchema>;

export const MetadataEntityQueryResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
  entity: MetadataSchema,
});

export type MetadataEntityQueryResult = z.infer<typeof MetadataEntityQueryResultSchema>;

export const MetadataEntityModifyResultSchema = FlatModels.EntityControlModels.SaveSnapshotItemSchema.extend({
  entity: MetadataSchema,
});

export type MetadataEntityModifyResult = z.infer<typeof MetadataEntityModifyResultSchema>;
